import { useState } from "react";
import {
  PostSpirometryData,
  PreSpirometryData,
  SpirometryValidationErrors,
  UpdateSpirometryValidationErrors
} from "../api/forms/spirometry/types";
import { Nullable } from "../api/types";
import { FormHandle } from "../types";
import PostSpirometyForm from "./data-input-forms/PostSpirometyForm";
import PreSpirometyForm from "./data-input-forms/PreSpirometyForm";

export default function SpirometryForms({
    preSpirometryRef,
    postSpirometryRef,
    setErrors,
}: {
    preSpirometryRef: React.RefObject<FormHandle<
        Nullable<PreSpirometryData>
    > | null>;
    postSpirometryRef: React.RefObject<FormHandle<
        Nullable<PostSpirometryData>
    > | null>;
    setErrors: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}) {
    const [preFormValues, setPreFormValues] = useState<
        PreSpirometryData | null | undefined
    >();
    const [postFormValues, setPostFormValues] = useState<
        PostSpirometryData | null | undefined
    >();
    const [validationErrors, setValidationErrors] =
        useState<SpirometryValidationErrors>({
            pre: {},
            post: {},
        });

    const updateValidationErrors: UpdateSpirometryValidationErrors = (
        formType,
        data
    ) => {
        setValidationErrors((prev) => ({
            ...prev,
            [formType]: {
                ...prev[formType],
                ...data,
            },
        }));
    };

    return (
        <div className="flex gap-2.5">
            <PreSpirometyForm
                ref={preSpirometryRef}
                formValues={preFormValues}
                setFormValues={setPreFormValues}
                setPostFormValues={setPostFormValues}
                setErrors={setErrors}
                validationErrors={validationErrors["pre"]}
                updateValidationErrors={updateValidationErrors}
            />
            <PostSpirometyForm
                ref={postSpirometryRef}
                formValues={postFormValues}
                setFormValues={setPostFormValues}
                setPreFormValues={setPreFormValues}
                setErrors={setErrors}
                validationErrors={validationErrors["post"]}
                updateValidationErrors={updateValidationErrors}
            />
        </div>
    );
}
